import classNames from "classnames"

import {
  ContentTag,
  DataItem,
  WidgetTag,
  provideComponent,
  useData
} from "scrivito"
import { CurrentUser } from "scrivito/Data/CurrentUser/CurrentUserDataItem"
import { DataBinary } from "shared/lib/dataBinaryToUrl"

import personCircle from "assets/images/person-circle.svg"

import { DataBinaryImage } from "widgets/data-binary-image/DataBinaryImage"

import { DataMessageWidget } from "./DataMessageWidgetClass"
import "./styles/_chat-message.scss"

provideComponent(DataMessageWidget, ({ widget }) => {
  const dataItem = useData().dataItem()
  const createdBy = dataItem?.get("createdBy")
  const currentUserPisaId = CurrentUser.get("pisaUserId")
  // const userInfo = useUserInfo()

  const user: DataItem | null = createdBy instanceof DataItem ? createdBy : null

  // const staff = user?.get("staff") || false
  // if (staff) classNamesArray.push("staff")

  // const currenUserPisaId = CurrentUser.get("pisaUserId")
  // const userId = user?.id()
  // const colleague = !staff && !!userId && userId !== currenUserPisaId
  const isMe = !user?.id() || currentUserPisaId === user?.id()

  const image = getImage()
  // getImage({
  //   dataItem,
  //   user,
  //   isMe,
  //   currentUserImage: userInfo?.picture
  // })

  return (
    <WidgetTag className={classNames("chat-message", { "is-me": isMe })}>
      <div className="avatar">
        <DataBinaryImage className="avatar-image" dataBinary={image} />
        <span className="avatar-text">
          {/* {staff ? "Staff" : null}
          {colleague ? "Colleague" : null} */}
        </span>
      </div>
      <div className="flex-grow-1">
        <div className="card mb-4 bg-white no-color-adaption">
          <ContentTag
            content={widget}
            attribute="content"
            className="card-body p-4"
            dataContext={dataItem}
          />
        </div>
      </div>
    </WidgetTag>
  )
})

// function getImage({
//   dataItem,
//   user,
//   isMe,
//   currentUserImage
// }: {
//   dataItem: DataItem | null
//   user?: DataItem | null
//   isMe?: boolean
//   currentUserImage?: string | null
// }): DataBinary {
//   if (currentUserImage && isMe) {
//     return { url: currentUserImage || personCircle }
//   }

//   const userImage = user?.get("image")
//   if (isDataBinary(userImage)) return userImage

//   return { url: personCircle }
// }

function getImage(): DataBinary {
  return { url: personCircle }
}
